module.exports = __webpack_public_path__ + "static/media/ill@3x.ba6c5242.png";